import { useState, useCallback } from "react";
import { dashboardBackendUrl } from "../../config/gateway";

interface Inventary {
  itemId: string;
  refId: string;
  createDate: string;
  nameProduct: string;
  cantSiesa: number;
  cantVtex: number;
  diference: number;
}

interface UseGetInventaryReturn {
  inventary: Inventary[] | null;
  loading: boolean;
  error: string | null;
  totalElements: number;
  fetchInventary: (page: number, size: number) => Promise<void>;
}

const useGetInventary = (): UseGetInventaryReturn => {
  const [inventary, setInventary] = useState<Inventary[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [totalElements, setTotalElements] = useState<number>(0);

  const fetchInventary = useCallback(async (page: number, size: number): Promise<void> => {
    setLoading(true);
    setError(null);

    try {
      const tokenStorage = localStorage.getItem("token");
      const token = tokenStorage ? tokenStorage.replace(/['"]+/g, '') : null;

      if (!token) {
        throw new Error("Token de acceso no encontrado. Inicia sesión primero.");
      }

      const response = await fetch(
        dashboardBackendUrl.inventoryMovements(page, size),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Error al obtener inventario: ${response.status} - ${response.statusText}`);
      }

      const data = await response.json();

      if (!data?.content) {
        throw new Error("Formato de respuesta inesperado. Se esperaba un array de inventario.");
      }

      setInventary(data.content);
      setTotalElements(data.totalElements);
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "Error desconocido al realizar la solicitud"
      );
    } finally {
      setLoading(false);
    }
  }, []);

  return { inventary, loading, error, totalElements, fetchInventary };
};

export default useGetInventary;